export default __webpack_public_path__ + "static/media/Behance.88fcdad1.svg";